import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface GalleryFilterStateType {
    year: number | null,
    page: number;
}

const initialState: GalleryFilterStateType = {
    year: null,
    page: 1,
};

export const galleryFilterSlice = createSlice({
    name: 'galleryFilter',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setYear: (state, action: PayloadAction<number | null>) => {
            state.page = 1;
            state.year = action.payload;
        },
        increasePage: (state) => {
            state.page += 1;
        },
    },
});

export const {
    setPage,
    setYear,
    increasePage
} = galleryFilterSlice.actions;

export default galleryFilterSlice.reducer;

// Correct selector based on slice name `galleryFilter`
export const galleryFilterSelector = (state: RootState) => state.galleryFilter;


export const pageSelector = createSelector(
    [galleryFilterSelector],
    (filters) => filters.page
);

export const yearSelector = createSelector(
    [galleryFilterSelector],
    (filters) => filters.year
);


export const gallerySelector = createSelector(
    [galleryFilterSelector],
    (filters) => filters
);
